module.exports = __webpack_public_path__ + "static/img/dianzi.90da040.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dianzi.png
// module id = dZ08
// module chunks = 52